import PropTypes from 'prop-types'
import React from 'react';
import { StyleSheet, View, TouchableOpacity, TextInput, } from 'react-native';
import Text from 'app/components/Text'
import apiActions from 'app/utils/apiActions'
import valueActions from 'app/utils/valueActions'
import textHelpers from 'app/utils/textHelpers'
import colorHelpers from 'app/utils/colorHelpers'
import { styleSheet, colors, sizes } from 'app/utils/styleSheet'
// import { navigationRef } from 'app/utils/RootNavigation';
import * as RootNavigation from 'app/utils/RootNavigation.js';

import Value from 'app/components/Value'
import Note from 'app/components/Note'
import DatePicker from 'app/components/DatePicker'
import { Ionicons, Entypo, Feather, MaterialIcons, FontAwesome, 
  MaterialCommunityIcons, } from '@expo/vector-icons';

export default class Inspector extends React.Component {

  static propTypes = {
    item: PropTypes.object.isRequired,
    parent: PropTypes.object.isRequired,
    onUpdate: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
  }

  constructor(props){
    let { parent, item } = props
    // let itemIsValue = item.value?.id != parent.id
    let itemIsValue = !!item?.id && typeof item.id !== 'string'
    console.log(item)

    let timestamp = item.timestamp

    let progressIndex = null
    let rawText = ''
    let text = ''

    if(itemIsValue){
      text = item.value.text
      rawText = text
    }
    else {
      text = item.note || ''
      if(text[1] == ':') text = text.substr(2)
      rawText = text
    }

    super(props)
    this.state = {
      rawText,
      itemIsValue,
      text,
      timestamp,
    }
  }

  render(){
    let { parent, item, onClose, onUpdate, } = this.props
    let { text, timestamp, progressIndex, itemIsValue, } = this.state

    return (
      <View style={styles.inspector}>

        <DatePicker 
          selected={new Date(timestamp)} 
          value={new Date(timestamp)} 
          onChange={timestamp => this.setState({timestamp})} 
          inputStyle={styles.input} 
        />

        <Note 
          expanded 
          text={text} 
          style={{maxWidth: 400}} 
          onChangeText={text => this.setState({text})}
          onCancel={onClose}
          // onSubmit={onUpdate}
          onSubmit={this.handleSubmit}
        />

        {this.renderActionRow(item, itemIsValue)}
      </View>
    )
  }

  renderActionRow = (item, itemIsValue) => {
    return (
      <View style={styles.actionRow}>
        <View style={{flexDirection: 'row', justifyContent: 'flex-start'}}>
          {!itemIsValue ? <Feather name='trash-2' style={styles.icon} onPress={() => this.props.deleteDoneAt(item.timestamp)} /> :
            <FontAwesome name='unlink' style={styles.icon} onPress={() => alert('break relationship')} />
          }
          <MaterialIcons name='control-point-duplicate' style={styles.icon} onPress={() => alert('duplicate')} />
        </View>
        <View style={{flexDirection: 'row', justifyContent: 'flex-end'}}>
          {itemIsValue && (
            <MaterialCommunityIcons name='timeline-text-outline' style={styles.icon} onPress={() => alert('history')} />
          )}
          {itemIsValue && (
            <Entypo name='chevron-right' style={styles.icon} 
              onPress={() => RootNavigation.push('Value', {id: item.value.id, value: item.value})} 
            />
          )}
        </View>
      </View>
    )
  }

  handleSubmit = async () => {
    let { parent, item, onUpdate, onClose, } = this.props
    let { timestamp, text, itemIsValue, } = this.state
    let value = null
    let data = {}
    if(itemIsValue){
      value = {
        id: item.value.id,
        completed_at: timestamp,
        text: text,
      }
      data = { respond_with_id: parent.id }
    }
    else {
      
      let progressAt = textHelpers.oldestFirst(parent.progress_at)
      let progressIndex = progressAt?.indexOf(item.timestamp)
      progressAt[progressIndex] = timestamp
      
      let newNote = `${progressIndex}:${text}`
      let notes = textHelpers.oldestFirst(parent.notes)
      if(!notes.find(n => n.startsWith(progressIndex))){
        notes.push(newNote)
      }
      else {
        notes = notes.map(n => n.startsWith(progressIndex) ? newNote : n)
      }
      notes = textHelpers.oldestFirst(notes)

      value = {
        id: parent.id,
        progress_at: progressAt,
        notes: notes,
      }
    }
    if(!!value){
      let updatedVal = await apiActions.request(`values/${value.id}`, 'PATCH', {value, ...data})
      console.log(updatedVal)
      if(!!updatedVal){
        value = updatedVal
        valueActions.updateValues(value)
        onUpdate(value)
        onClose()
      }
    }
  }

}

const styles = StyleSheet.create({  
  inspector: {
    backgroundColor: colorHelpers.hexToRgbaString(colors.fill, 0.9),
  },
  actionRow: {
    alignSelf: 'stretch',
    flexDirection: 'row', 
    justifyContent: 'space-between',
  },
  icon: {
    ...styleSheet.icon,
    paddingHorizontal: sizes.small,
    paddingVertical: 0,
  },
})